import s from './LinkButton.module.scss';

const LinkButton = ({ href, children, onClick, icon, className, variant }) => {
  const Component = href ? 'a' : 'button';
  return (
    <Component
      className={`${s.linkButton} ${className} ${s[variant]}`}
      href={href}
      onClick={onClick}
    >
      <span>{children}</span>
      {icon && <span className={s.icon}>{icon}</span>}
    </Component>
  );
};

export default LinkButton;
